import RXPMWPage from "components/pages/RXPMWPage";

export default function CaptureMabiCheckFreeMobile(props) {
    return <RXPMWPage />
}